module.exports = __webpack_public_path__ + "img/Studio des langues.fa5abfd5.svg";